// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls1":"_1oMz1","cls2":"RHLzB","cls3":"_1bqkQ","cls4":"End4A"};